import { SecondaryNavItem } from "../navigation/SecondaryNavigation";

/**
 * Filters navigation items based on user role
 * @param items Navigation items to filter
 * @param userRole The user's role
 * @returns Filtered navigation items
 */
export function filterNavItemsByRole(
  items: SecondaryNavItem[],
  userRole: string | undefined
): SecondaryNavItem[] {
  // Admin-only section names
  const adminOnlySections = ["Organisations", "Team members", "Audit Logs"];
  
  // If user is admin, return all items
  if (userRole?.toLowerCase() === "admin") {
    return items;
  }
  
  // Otherwise filter out admin-only sections
  return items.filter(item => !adminOnlySections.includes(item.name));
}
